export const GAME_IDS = ["minigolf", "eightball", "cuppong", "wordhunt"] as const;

export type GameId = (typeof GAME_IDS)[number];

export type GameStatus = "playable" | "planned";

export type GameDefinition = {
  id: GameId;
  title: string;
  shortTitle: string;
  tag: string;
  summary: string;
  players: string;
  status: GameStatus;
};

export const DEFAULT_GAME_ID: GameId = "minigolf";

export const GAME_CATALOG: GameDefinition[] = [
  {
    id: "minigolf",
    title: "Mini Golf",
    shortTitle: "Golf",
    tag: "Live race",
    summary: "Pan, pull, and putt through random courses with ghost balls.",
    players: "1-4",
    status: "playable",
  },
  {
    id: "eightball",
    title: "8-Ball",
    shortTitle: "8-Ball",
    tag: "Pool table",
    summary: "Cue up a touch-first pool table with live shared shots.",
    players: "1-2",
    status: "playable",
  },
  {
    id: "cuppong",
    title: "Cup Pong",
    shortTitle: "Pong",
    tag: "Arc shots",
    summary: "Pull back, lob, and clear the rack before the table does.",
    players: "1-4",
    status: "playable",
  },
  {
    id: "wordhunt",
    title: "Word Hunt",
    shortTitle: "Words",
    tag: "Word rush",
    summary: "Swipe timed word paths on a shared board with live scores.",
    players: "1-4",
    status: "playable",
  },
];

export function gameById(value: unknown): GameDefinition {
  return GAME_CATALOG.find((game) => game.id === normalizeGameId(value)) ?? GAME_CATALOG[0];
}

export function normalizeGameId(value: unknown): GameId {
  return GAME_IDS.includes(value as GameId) ? (value as GameId) : DEFAULT_GAME_ID;
}

export function isPlayableGame(value: unknown): boolean {
  return gameById(value).status === "playable";
}
